import { useFirestoreCollection } from "@p0security/frontend-core/react";
import type {
  IntegrationConfig,
  OldOrNewConfig,
} from "@p0security/shared/integrations/shared";
import { createContext, useMemo } from "react";

export const IntegrationsContext = createContext<
  Record<string, OldOrNewConfig>
>({});

/** Loads every integration for this tenant
 *
 * Return value is a record of installed (or partially installed) integrations to
 * Firestore document data.
 */
export const IntegrationsContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { docs } = useFirestoreCollection<IntegrationConfig>("integrations", {
    live: true,
    tenantAware: true,
  });
  const configs = useMemo(
    () => Object.fromEntries((docs ?? []).map((c) => [c.id, c.data])),
    [docs]
  );
  return (
    <IntegrationsContext.Provider value={configs}>
      {children}
    </IntegrationsContext.Provider>
  );
};
